/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import * as Styles from '../../../../SharedModules/StyleConstant/StyleConstant';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

const textMatcher = ({ filterOption, value: val, filterText }) => {
  const value = Math.abs(val).toString();
  const valueWithDollar = `$ ${value}`;
  if (filterText == null) {
    return false;
  }
  switch (filterOption) {
    case 'contains':
      return (
        value.indexOf(filterText) >= 0 ||
        valueWithDollar.indexOf(filterText) >= 0
      );
    case 'notContains':
      return (
        value.indexOf(filterText) < 0 || valueWithDollar.indexOf(filterText) < 0
      );
    case 'equals':
      return value === filterText || valueWithDollar.indexOf(filterText) === 0;
    case 'notEqual':
      return value != filterText.replace('$', '');
    case 'startsWith':
      return (
        value.indexOf(filterText) === 0 ||
        valueWithDollar.indexOf(filterText) === 0
      );
    case 'endsWith':
      const index =
        value.lastIndexOf(filterText) || valueWithDollar.indexOf(filterText);
      return index >= 0 && index === value.length - filterText.length;
    default:
      return false;
  }
};

const comparatorQtr = (a, b, nodeA, nodeB, isDescending) => {
  const splittedQtrA = a.split('Q');
  const splittedQtrB = b.split('Q');
  return splittedQtrA[1] - splittedQtrB[1] || splittedQtrA[0] - splittedQtrB[0];
};

export const disputeAmountsTableHead = [
  {
    headerName: 'QTR',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'GenericCodeTextBox',
    comparator: comparatorQtr,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amount in Dispute',
    field: 'amt_IN_DISP',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    wrapText: true,
    autoHeight: true,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,

      textMatcher,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Curr Total Invoice Amount',
    field: 'c_TOT',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_180,
    wrapText: true,
    autoHeight: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      textMatcher,
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'PCT Disp of Total Invoice',
    field: 'pct_DISP_OF_TOT_INVOICE',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    minWidth: Styles.Width_160,
    decimalunit: 4,
    exportZeroesFour: true,
    cellRenderer: CustomGridCellRendererComponent,
    printPostfixValue: '%',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,

      textMatcher,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Curr Amt Disp Drug',
    field: 'curr_AMT_DISP_DRUGS',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    minWidth: Styles.Width_171,
    cellRenderer: CustomGridCellRendererComponent,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    printPrefixValue: '$',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
  {
    headerName: 'Pct Disp of Disp Drug',
    field: 'pct_DISP_OF_DISP_DRUGS',
    editable: false,
    wrapText: true,
    autoHeight: true,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    decimalunit: 4,
    exportZeroesFour: true,
    cellRenderer: CustomGridCellRendererComponent,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },
    printPostfixValue: '%',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
    alignment: 'right',
    isTextColorRed: true,
  },
];

export const ManufactureTableHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    editable: false,
    suppressMenu: false,
    sortable: true,
    sort: 'asc',
    minWidth: Styles.Width_200,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },

    filter: 'agTextColumnFilter',
    wrapText: true,
    autoHeight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },
    wrapText: true,
    autoHeight: true,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const ndcTableHeads = [
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    cellStyle: { borderRightColor: Styles.BorderColor },

    filter: 'agTextColumnFilter',
    wrapText: true,
    autoHeight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_400,
    columnSpan: 2,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  // {
  //   headerName: '',
  //   field: '',
  //   removeColumn: true,
  //   minWidth: 1,
  //   resizable: false,
  //   editable: false,
  // },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
    
  },

  {
    headerName: 'Amount in Dispute',
    field: 'amontInDispute',
    editable: false,
    alignment:'left',
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    printPrefixValue: '$',
    cellRenderer: CustomGridCellRendererComponent,

    cellStyle: { borderRightColor: Styles.BorderColor, textAlign: 'right' },

    filter: 'agTextColumnFilter',

    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
    // alignment: 'right',
    isTextColorRed: true,
  },
  // {
  //   headerName: '',
  //   field: '',
  //   removeColumn: true,
  //   minWidth: 1,
  //   resizable: false,
  //   editable: false,
  // },
  {
    headerName: 'Dispute Codes',
    field: 'disputeCodes',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',

    cellStyle: { borderRightColor: Styles.BorderColor },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const exportAllPDFTableHead = [
  {
    headerName: 'QTR',
    field: 'qtr',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    comparator: comparatorQtr,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    wrapText: true,
    autoHeight: true,

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_150,
    cellRenderer: 'GenericCodeTextBox',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    filter: 'agTextColumnFilter',
    wrapText: true,
    autoHeight: true,
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_400,
    cellRenderer: 'TextBoxRender',
    cellClass: 'frr-ellipsis-text',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },

  {
    headerName: 'Amount in Dispute',
    field: 'amt_IN_DISP',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    cellRenderer: CustomGridCellRendererComponent,
    isTextColorRed: true,
    isAmount: true,
    printPrefixValue: '$',
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,

      textMatcher,
    },
    alignment: 'right',
  },
  {
    headerName: 'Dispute Codes',
    field: 'disputeCodes',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_100,
    cellRenderer: 'GenericCodeTextBox',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Curr Total Invoice Amount',
    field: 'c_TOT',
    editable: false,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    wrapText: true,
    autoHeight: true,
    isAmount: true,
    cellRenderer: CustomGridCellRendererComponent,
    isTextColorRed: true,
    printPrefixValue: '$',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      textMatcher,
      refreshValuesOnOpen: true,
    },
    alignment: 'right',
  },
  {
    headerName: 'Pct Disp of Total Invoice',
    field: 'pct_DISP_OF_TOT_INVOICE',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    minWidth: Styles.Width_200,
    decimalunit: 4,
    exportZeroesFour: true,
    cellRenderer: CustomGridCellRendererComponent,
    isTextColorRed: true,
    printPostfixValue: '%',
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,

      textMatcher,
    },
    alignment: 'right',
  },
  {
    headerName: 'Curr Amt Disp Drug',
    field: 'curr_AMT_DISP_DRUGS',
    editable: false,
    suppressMenu: false,
    wrapText: true,
    autoHeight: true,
    sortable: true,
    isAmount: true,
    minWidth: Styles.Width_200,
    cellRenderer: CustomGridCellRendererComponent,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    isTextColorRed: true,
    printPrefixValue: '$',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
    alignment: 'right',
  },
  {
    headerName: 'Pct Disp of Disp Drug',
    field: 'pct_DISP_OF_DISP_DRUGS',
    editable: false,
    wrapText: true,
    autoHeight: true,
    suppressMenu: false,
    sortable: true,
    minWidth: Styles.Width_200,
    decimalunit: 4,
    exportZeroesFour: true,
    cellRenderer: CustomGridCellRendererComponent,
    cellEditorParams: {
      maxLength: 5,
      custWidth: '135px',
    },
    isTextColorRed: true,
    printPostfixValue: '%',

    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher,
    },
    alignment: 'right',
  },
];
